// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : SANCTION REPORT
// MODIFIED DATE: 29-09-2025
const sanctionReportTypes = {
	/*********** GET SANCTION REPORT START ****************** */
	GET_SANCTION_REPORT_START: 'get_sanction_report_start',
	GET_SANCTION_REPORT_SUCCESS: 'get_sanction_report_success',
	GET_SANCTION_REPORT_FAILURE: 'get_sanction_report_failure',
	GET_SANCTION_REPORT_RESPONSE_RESET_START: 'get_sanction_report_reponse_reset',
	GET_SANCTION_REPORT_RESPONSE_CHANGED: 'get_sanction_report_reponse_changed',
	/*********** GET SANCTION REPORT END ****************** */
};
export default sanctionReportTypes;
